import { render, staticRenderFns } from "./Commit.vue?vue&type=template&id=52f93d7e&scoped=true&"
import script from "./Commit.vue?vue&type=script&lang=js&"
export * from "./Commit.vue?vue&type=script&lang=js&"
import style0 from "./Commit.vue?vue&type=style&index=0&id=52f93d7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f93d7e",
  null
  
)

export default component.exports